import { useIntl } from 'react-intl';

export const useFormatText = () => {
  const intl = useIntl();
  const formatText = (
    id: string,
    values?: Record<string, string | number | boolean>
  ) => {
    if (intl.messages[id]) {
      return intl.formatMessage({ id }, values);
    }
    return id;
  };

  return { formatText };
};
